import { Flex, Spinner } from '@raystack/apsara';

import { ReactComponent as Logo } from '@src/containers/LoginPage/Logo.svg';

const AppLoader = () => {
  return (
    <Flex
      justify='between'
      style={{
        width: '100%',
        height: '100vh',
        background: 'var(--rs-color-background-base-primary)'
      }}
    >
      <Flex
        direction='column'
        gap='extra-small'
        justify='center'
        align='center'
        style={{ width: '100%' }}
      >
        <Logo style={{ width: 100, height: 'auto' }} />
        <Spinner size={6} />
      </Flex>
    </Flex>
  );
};

export default AppLoader;
